import React, { useEffect, useCallback, useState, useRef} from 'react';
import {useConsumeWheel} from "components/hooks/useConsumeWheel.js"
import {PLANAR_SCRIPT} from 'constants/script-types.js';
import UserScriptComponent from "components/effects/scripting/UserScriptComponent.js";
import {doc} from 'effects/midi/mappable/lang/documentation.js';
import GroupGeneticAlgo from './GroupGeneticAlgo.js';
import EffectParameterSlider from '../EffectParameterSlider.js';
import Dropdown from 'react-dropdown';
import GroupSequencer from './GroupSequencer.js';
import {SCRIPT, SWAP, SPIRAL, NAVIER, ROTATE, BOUNCE_1, BOUNCE_2, LIFE, NONE} from 'effects/midi/mappable/lang/operations.js';
import {connect} from 'react-redux';

const NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
const OPTIONS = [
    {label: "None", value: NONE},
    {label: "Fluid", value: NAVIER},
    {label: "Script", value: SCRIPT},
    {label: "Bounce 1", value: BOUNCE_1},
    {label: "Bounce 2", value: BOUNCE_2},
    {label: "Life", value: LIFE},
    {label: "Rotate", value: ROTATE},
    {label: "Spiral", value: SPIRAL},
    {label: "Swap", value: SWAP},
];

const PlaneAlgo = ({isDraggable, selected, effect, setExpanded, expanded}) => { 
    let ref = useRef(undefined);
    useConsumeWheel(ref);
    if ((!selected[0] || !selected[0].hasGroup) && !expanded) {
        return (
            <div>
            </div>
        );
    }

    // otherwise its a group
    let group = selected[0] && selected[0].hasGroup
        ? selected[0].hasGroup : effect.groups[0];
    if (!group) {
        return '';
    }
    return (
        <div ref={ref} className="plane-group-config">
        <div className="plane-algo">
          <Dropdown
            className='osc-type-dropdown'
            controlClassName='osc-type-control-dropdown'
            arrowClassName='osc-type-arrow-dropdown'
            options={OPTIONS}
            onChange={(o) => group.algorithmParameter.set(o.value)}
            value={OPTIONS.find(x => x.value === group.algorithm)}
            placeholder="Algorithm" />
          <EffectParameterSlider
            name={'Speed'}
            parameter={group.speedParameter}
            isParameter={true}
            sequencerEngine={effect.track.sequencerEngine}
            lfoEnabled={true}
            root={3}
            step={0.01}
            min={0.01}
            max={30}/>
        </div>
          {!expanded && group.algorithm == SCRIPT ?
           <UserScriptComponent
             isDraggable={isDraggable}
             scriptType={PLANAR_SCRIPT}
             setExpanded={setExpanded}
             doc={doc}
             sequencerEngine={group.track.sequencerEngine}
             effect={group}/> :
           ''}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let {selected} = props;
    let group = (selected && selected[0] && selected[0].hasGroup) ||
        props.effect.groups[0];;
    return {
        algo: group && group.algorithm
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaneAlgo);
